import { InputFormik } from "@/components/ui/input-formik"
import { InputMask } from "@/components/ui/input-mask"
import { Label } from "@/components/ui/label"
import Select from "react-select"
import { CidadeDto } from "@/services/CidadesService"
import { MASCARA_CEP, MASCARA_TELEFONE } from "@/utils/Constants"

export interface EtapaCadastrarProps {
    formik: any,
    submiting: boolean,
    cidades: CidadeDto[],
}

export function EtapaCadastrar({ formik, submiting, cidades }: EtapaCadastrarProps) {
    const cidadesSelect = [{ value: '', label: 'Selecione sua Cidades' }, ...cidades.map(cidade => ({ value: cidade.cidade, label: cidade.cidade }))];

    return (
        <div className="mt-5">
            <div className="grid gap-2 text-primary-foreground">
                <div className="flex items-center text-primary-foreground">
                    <Label htmlFor="cep">Digite seu CEP ou Selecione sua Cidade</Label>
                </div>
                <InputMask
                    name='CEP'
                    mask={MASCARA_CEP}
                    placeholder="CEP"
                    type="text"
                    id="CEP"
                    formik={formik}
                />

                <Select
                    defaultValue={{ value: '', label: 'Selecione sua Cidade' }}
                    options={cidadesSelect}
                    onChange={async (e) => {
                        formik.setFieldValue('Cidade', e!.value)
                    }}
                    isMulti={false}
                    className='form-control text-start text-sm z-50' />
            </div>
            <div className="flex flex-col gap-1 mt-4">
                <Label className="text-center text-primary font-semibold" htmlFor="nome">Nome Completo</Label>
                <InputFormik
                    disabled={submiting}
                    type="text"
                    className="text-center text-primary text-2xl"
                    id="Nome"
                    required
                    formik={formik}
                    name='Nome'
                />
            </div>
            <div className="flex flex-col gap-1 mt-4">
                <Label className="text-center text-primary font-semibold"
                    htmlFor="nome">Telefone</Label>
                <InputMask
                    type="text"
                    id="Telefone"
                    className="text-center text-primary text-2xl"
                    required
                    formik={formik}
                    name='Telefone'
                    mask={MASCARA_TELEFONE}
                />
            </div>
            <div className="flex flex-col gap-1 mt-4">
                <Label className="text-center text-primary font-semibold"
                    htmlFor="nome">Email</Label>
                <InputFormik
                    disabled={submiting}
                    type="text"
                    className="text-center text-primary text-2xl"
                    id="Email"
                    required
                    formik={formik}
                    name='Email'
                />
            </div>
        </div>
    )
}